import "font-awesome/css/font-awesome.min.css";
import Vue, { CreateElement, VNode } from "vue";
import Vuetify from "vuetify/lib/framework";

import colors from "vuetify/lib/util/colors";
import { VTab } from "vuetify/lib";

Vue.use(Vuetify);

// A Vuetify VTab a render()-jében fixen tabindex="0"-t ír ki, függetlenül attól, hogy a fül
// disabled-e (vuetify/lib/components/VTabs/VTab.js) — emiatt Tabbal a letiltott fülekre is
// rá lehet állni, pedig kattintással nem választhatók (pointer-events: none).
// Itt egyszer, központilag vesszük ki a letiltott füleket a fókusz-sorból, így minden
// v-tab-ra érvényes (dimenzió-fülek, riport-definíció, számlafolyam stb.).
type TabRender = (this: Vue & { disabled: boolean }, h: CreateElement) => VNode;
const vTabOptions = (VTab as unknown) as { options: { render: TabRender } };
const originalTabRender = vTabOptions.options.render;
vTabOptions.options.render = function (h) {
  const vnode = originalTabRender.call(this, h);
  if (this.disabled && vnode.data) {
    vnode.data.attrs = { ...vnode.data.attrs, tabindex: -1, "aria-disabled": "true" };
  }
  return vnode;
};

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#f67a1c",
        secondary: colors.grey.darken1,
        accent: colors.shades.black,
        error: colors.red.accent3,
      },
      dark: {
        primary: colors.blue.lighten3,
      },
    },
  },
  icons: {
    iconfont: "fa4",
  },
});
